// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__21WKy","row":"styles_row__b6ZgH"};